/* eslint-disable */

/** unique or primary key constraints on table "argo.material_class_process" */
export enum ArgoMaterialClassProcessConstraint {
  /** unique or primary key constraint on columns "material_class_process_id" */
  MaterialClassProcessPkey = 'material_class_process_pkey',
  /** unique or primary key constraint on columns "material_class_id", "process_id" */
  MaterialClassProcessUnique = 'material_class_process_unique'
}

/** select columns of table "argo.material_class_process" */
export enum ArgoMaterialClassProcessSelectColumn {
  /** column name */
  Active = 'active',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

/** select "argo_material_class_process_aggregate_bool_exp_bool_and_arguments_columns" columns of table "argo.material_class_process" */
export enum ArgoMaterialClassProcessSelectColumnArgoMaterialClassProcessAggregateBoolExpBoolAndArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** select "argo_material_class_process_aggregate_bool_exp_bool_or_arguments_columns" columns of table "argo.material_class_process" */
export enum ArgoMaterialClassProcessSelectColumnArgoMaterialClassProcessAggregateBoolExpBoolOrArgumentsColumns {
  /** column name */
  Active = 'active'
}

/** update columns of table "argo.material_class_process" */
export enum ArgoMaterialClassProcessUpdateColumn {
  /** column name */
  Active = 'active',
  /** column name */
  ContextId = 'context_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  CreatedById = 'created_by_id',
  /** column name */
  Id = 'id',
  /** column name */
  MaterialClassId = 'material_class_id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ProcessId = 'process_id',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  UpdatedById = 'updated_by_id'
}

